import { render, staticRenderFns } from "./HubConfigTab.vue?vue&type=template&id=a312090a&"
import script from "./HubConfigTab.vue?vue&type=script&lang=js&"
export * from "./HubConfigTab.vue?vue&type=script&lang=js&"
import style0 from "./HubConfigTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports